import { render } from "./ReleaseMemory.vue?vue&type=template&id=6ebe0218&scoped=true"
import script from "./ReleaseMemory.vue?vue&type=script&lang=js"
export * from "./ReleaseMemory.vue?vue&type=script&lang=js"

import "./ReleaseMemory.vue?vue&type=style&index=0&id=6ebe0218&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebe0218"]])

export default __exports__